export class BeanRequest {
    idInstitucion: number;
    idTipoBin: number; 
    bin:string;
    enviado:boolean;
    binValid:boolean=false;
    fechaSolicitud:Date;
    origenInfo: number;
    idGrupo: number;
    binesList: string;
}

export class PlantillaModel {
    idInstitucion: number;
    idTipoBin: number;
    idPlantilla: number;
    seccionesResponse:Array<SeccionModel>;
    bin:string;
    
}

export class CamposConfigModel {
    idCampoPk: number;
    dsc: string;
    tipoCampo: number;
    longitud:number;
    precision:string
    orden: number;
    requerido: number;
    estatus: number;
    expresionRegular:string;
    valoresSelResponse:Array<any>;
    valid:boolean;
    valor:any;
    touched:boolean;
    disabled:boolean;
    validBlanck:boolean = false;
    modificado:boolean = false;
}
export class SeccionModel{
    idSeccionPk: number;
    dsc:string;
    camposConfig:Array<CamposConfigModel>;
    valid:boolean;
    numeroSeccion:number;
    isSeccionInternacional:Boolean = false;
}

